/** 온라인 계약 약관 (contracttext.txt) */
export const CONTRACT_TERMS_TEXT = `제 1 조 [목적]
본 계약의 목적은 '갑'의 의뢰에 의해 '을'이 웹 또는 앱을 제작함(이하 '웹/앱 제작')에 있어 필요한 제반 사항 및 신의성실에 따른 당사자 간의 권리와 의무를 규정함에 있다.

제 2 조 [용어의 정의]
(1) 웹/앱 제작: Web, App 및 DB 서버에서 운영되는 온라인 시스템을 '갑'의 요청에 맞춰 프로그래밍 언어 및 디자인 요소로 종합 구성하여 구축하는 것.
(2) 세부개발기능 명세서(또는 작업지시서): '을'이 제공하는 제작 서비스의 범위, 명세, 부가서비스 내용이 기재된 서류.
(3) 하자: 납품된 결과물이 당초 합의된 제2조 (2)항의 세부개발기능 명세서와 명백히 다르게 작동하거나 발생하는 프로그램상의 기능적 오류.
(4) 유지보수: 검수 완료 후 제공되는 서비스로서, 납품된 결과물의 동일성을 유지하는 범위 내에서 '하자'를 수정하는 작업.

제 3 조 [용역의 범위]
(1) 용역의 범위는 '갑'과 '을'이 합의하여 작성한 세부개발기능 명세서(또는 견적서)에 명시된 개발 범위에 한하며, 계약금액 및 일정은 이에 따른다.
(2) '을'은 상기 작업범위에 명시되지 아니한 경미한 수정 사항에 대해 1회에 한하여 수행할 수 있으나, 과업 범위를 벗어나는 추가 기능 개발이나 공수가 과도하게 소요되는 요구는 별도의 계약 및 추가 금액을 체결하여 진행한다.

제 4 조 [소유권 및 저작권]
(1) '갑'은 본 계약에 따른 구축 대금을 전액 완납함과 동시에 '을'이 제공한 최종 결과물의 소유권 및 비독점적 사용권을 취득한다.
(2) '을'이 본 계약 이전부터 보유하고 있던 모듈, 프레임워크, 엔진, 오픈소스 및 범용 프로그램 소스코드의 저작권 등 지적재산권은 '을'에게 유보되며, '갑'에게는 본 프로젝트 목적 범위 내에서의 사용권이 부여된다.

제 5 조 [‘갑’의 권리 및 의무]
(1) '갑'은 구축대금의 완납과 동시에 본 계약에 따른 결과물의 소유권 및 사용권을 주장할 수 있다.
(2) '갑'은 '을'이 요청하는 자료(텍스트, 이미지, 계정 정보 등)를 지정된 기일 내에 제공하여야 하며, '갑'이 제공한 자료로 인해 발생하는 저작권, 초상권 등 제3자의 권리 침해에 대한 모든 법적 책임은 '갑'이 부담한다.
(3) '갑'의 자료 제공 지연, 검수 지연, 승인 지연 등의 사유가 발생하는 경우, 지연된 기간만큼 전체 제작 일정은 자동으로 연장된다.

제 6 조 [‘을’의 권리 및 의무]
(1) '을'은 '갑'과 합의한 사양에 따라 성실히 결과물을 제작하며, 필요한 경우 대행사나 전문 외주 인력을 활용할 수 있다.
(2) '을'은 제작 진행 상황에 대하여 '갑'에게 주기적으로 보고하며 '갑'의 합리적인 문의에 성실히 응대한다.
(3) 대금 완납 시 '을'은 '갑'이 운영에 필요한 최종 소스코드 및 관련 결과물 일체를 '갑'에게 전달(이관)한다.

제 7 조 [제작 절차 및 일정]
(1) 서비스 신청 및 자료 제공: '갑'과 '을'이 세부개발기능 명세서를 확정하고, '갑'이 제작에 필요한 기본 자료 전체를 '을'에게 전달한 시점부터 제작 기간을 산정한다.
(2) 인도 및 검수: '을'은 제작 완료 후 결과를 테스트 서버 또는 스토어 등에 게시하고 '갑'에게 검수를 요청한다.
(3) 제작 완료: 제9조의 검수 절차에 따라 '갑'의 검수가 완료되거나 검수한 것으로 간주된 때에 제작이 최종 완료된 것으로 본다.

제 8 조 [제작 기간]
(1) 제작 기간은 계약서에 명시된 기간을 따른다.
(2) '갑'의 요구에 의한 사양 변경, 추가 개발, 자료 제공 지연 또는 '갑'의 승인 지연이 발생할 경우, 해당 기간만큼 제작 기한은 자동으로 연장된다.
(3) '을'은 불가항력적 사유나 부득이한 사태로 납기 지연이 예상되는 경우, 이를 즉시 '갑'에게 통지하고 일정을 협의하여 조정할 수 있다.

제 9 조 [검수 방법 및 하자 보수]
(1) '을'은 개발 완료 후 '갑'에게 서면 또는 메일로 검수를 요청하며, '갑'은 통보받은 날로부터 [7일] 이내에 계약 범위와의 일치 여부를 검수하여야 한다.
(2) '갑'이 검수 기간[7일] 이내에 정당한 사유 없이 수정 요청 사항을 서면으로 제출하지 않거나, 결과물을 실제 상용 서비스(운영)에 이용하는 경우, 검수에 합격하여 제작이 완료된 것으로 간주한다.
(3) 검수 과정에서 계약 범위 내의 하자가 발견되어 '갑'이 수정을 요청할 경우, '을'은 이를 지체 없이 보완하여 재검수를 받는다.
(4) 검수 완료(또는 간주) 후 발생하는 하자는 상기 내용에 지정된 '유지보수(무상 하자보수) 기간' 동안 제2조 (4)항에 따라 처리하며, 과업 범위를 벗어난 단순 변경/추가 요청은 유상으로 진행한다.

제 10 조 [교육훈련]
'을'은 '갑'의 요청이 있을 경우, 납품 완료 후 산출물 운용에 필요한 시스템 매뉴얼 제공 또는 1회(온라인 또는 2시간 이내)의 교육을 실시한다.

제 11 조 [업무진행방법 및 과업 변경]
(1) '갑'과 '을'이 상호 서면(이메일, 메신저 포함)으로 확인한 관련 문서는 계약서와 동일한 효력을 갖는다.
(2) '갑'은 정해진 업무 내용의 변경을 요청할 수 있으나, 이미 합의되어 완료된 단계의 재작업이나 최초 개발 범위를 넘어서는 요구는 '을'의 공수 산정에 따라 별도 계약 체결 및 추가 비용을 지급한 후 진행한다.

제 12 조 [무상 하자보수 및 유지보수]
(1) '을'은 검수 완료일로부터 [1년]간 '을'의 귀책사유로 인하여 발생한 제2조 (3)항의 명백한 하자(프로그램적 오류)에 한하여 무상으로 보수한다.
(2) 무상 하자보수 범위를 벗어난 신규 기능 추가, 디자인 변경, 운영 대행 등은 별도의 유상 유지보수 계약을 체결하여 진행한다.

제 13 조 [자료의 관리 및 보안]
'을'은 '갑'이 제공한 각종 자료를 당초 제작 목적 이외의 용도로 사용하거나 사전 동의 없이 제3자에게 누설하지 않는다.

제 14 조 [제작비용의 지급 및 대금 불이행]
(1) '갑'은 본 계약서에 명시된 지급 일정 및 방법에 따라 '을'에게 제작비용을 지급한다.
(2) '갑'이 약정된 기일 내에 대금을 지급하지 아니하는 경우, '을'은 작업 진행을 중단할 수 있으며, 이로 인한 납기 지연에 대해 '을'은 책임을 지지 아니한다.
(3) '갑'이 계약대금 전액을 완납한 때에 한하여 결과물의 소유권 및 소스코드 이관 의무가 발생한다.

제 15 조 [계약의 해제 및 해지]
(1) 양 당사자는 상대방이 본 계약상의 중대한 의무를 위반하고 14일 이상의 기간을 정하여 서면으로 시정을 최고하여도 이를 이행하지 아니하는 경우 계약을 해제 또는 해지할 수 있다.
(2) 계약 해지 시 정산 및 결과물의 인도 기준은 제16조(손해배상 및 정산)에 따른다.

제 16 조 [손해배상 및 정산]
(1) '갑'과 '을'이 본 계약상의 의무를 이행하지 아니하여 상대방에게 손해를 입힌 경우 그 손해를 배상할 책임이 있다.
(2) '을'의 귀책사유로 본 계약이 해제 또는 해지되는 경우, '을'은 '갑'으로부터 받은 대금 전액을 반환하여야 하며, 이와 별도로 본 계약의 불이행으로 인하여 '갑'에게 실제로 발생한 입증된 손해를 배상한다.
(3) '을'의 귀책사유 없이 '갑'의 임의로 계약을 해지하는 경우, 다음 각 호에 따라 정산한다.
가. 착수금 납입 후 제작 착수 전 해지 시: 이미 납입된 착수금은 '을'에게 귀속되며 반환하지 아니한다.
나. 제작 진행 중 해지 시: '을'은 '갑'이 정산금을 완납하는 조건으로 해지 시점까지 제작된 성과물을 '갑'에게 인도하고, '갑'은 아래 진행 공정률 기준(총 계약금액 대비)에 해당하는 금액에서 기지급된 대금을 정산한 후 부족분을 '을'에게 추가 지급한다.
[진행 단계별 기준: 착수 완료: 30% / 시안 진행: 40% / 레이아웃 진행: 50% / 콘텐츠 진행: 60% / 개발 진행: 80% / 납품 진행: 90% / 검수 진행: 100%]
(4) '을'이 제공한 최종 납품물에 대하여 제3자가 지적재산권 침해를 이유로 '갑'에게 클레임 또는 소송을 제기한 경우, '갑'은 즉시 '을'에게 이를 서면으로 통보하여야 하며, '을'은 자신의 비용과 책임으로 '갑'을 방어하고 면책하기 위해 최선을 다한다. 단, 다음 각 호의 경우에는 '을'이 책임을 지지 아니하며, '을'의 전체 배상 책임 한도는 본 계약의 총 계약금액을 초과할 수 없다.
가. '갑'이 제공한 자료, 지시, 사양으로 인하여 발생한 경우
나. '을'의 동의 없이 '갑'이 납품물을 임의로 수정·변형하여 발생한 경우
(5) 상기 (4)항의 클레임이 제기된 경우, '을'은 자체 비용으로 '갑'이 해당 산출물을 계속 사용할 수 있도록 합법적인 사용권을 확보하거나, 동일 또는 유사한 기능 수준으로 수정·대체하여야 한다. 단, '갑'이 제공한 자료나 지시로 인하여 발생한 클레임의 경우에는 그러하지 아니하다.

제 17 조 [대금의 청구 및 지급]
(1) '을'은 용역실행계획서(또는 계약서)에 명기된 청구 시점에 세금계산서를 '갑'에게 발행하여 계약대금을 청구한다.
(2) '갑'은 지정된 결제수단으로 착수금을 납입하며, '을'이 작업에 착수하기 전일 경우에 한하여 납입일로부터 7일 이내에 계약을 철회할 수 있다. 단, 이미 작업이 시작된 경우 제16조의 정산 규정에 따른다.
(3) '갑'이 '을'에게 청구할 지체상금 등 확정된 배상금이 있는 경우, 양 당사자의 서면 합의를 거쳐 지급할 계약대금에서 상계할 수 있다.

제 18 조 [지체보상금]
(1) '을'의 직접적인 귀책사유로 인하여 정당한 사유 없이 납기 내에 납품이 지체된 경우, '을'은 '갑'에게 지체일수 1일당 미납품금액의 1,000분의 1(0.1%)에 해당하는 지체보상금을 정산한다. 단, 지체보상금의 총액은 총 계약금액의 30%를 초과할 수 없다.
(2) '갑'은 다음 각 호의 사유에 의하여 지체되었을 경우 '을'의 책임을 면제하며, 해당 기간만큼 납기를 자동 연장한다.
가. 천재지변 등 불가항력적인 사유에 의한 경우
나. '갑'의 자료 제출 지연, 기획/시안 승인 및 검수 지연(요청일로부터 3영업일 초과 시), 피드백 지연 또는 사양 변경 요청에 의한 경우
다. 기타 '을'의 책임에 속하지 않는 사유에 의한 경우

제 19 조 [계약의 양도금지]
'갑'과 '을'은 상대방의 서면 동의 없이 본 계약상의 권리와 의무를 제3자에게 양도하거나 담보로 제공할 수 없다.

제 20 조 [비밀유지]
(1) '갑'과 '을'은 본 계약의 이행 과정에서 알게 된 상대방의 영업상, 기술상의 비밀정보를 상대방의 사전 서면 승인 없이 제3자에게 누설하거나 본 계약 이외의 목적으로 사용하여서는 아니 된다.
(2) '을'이 활용하는 재하도급/대행사의 비밀유지 의무 위반에 대한 책임은 '을'이 부담한다.
(3) 본 조의 비밀유지의무는 본 계약이 해제, 해지 또는 만료된 후에도 2년간 유효하게 존속한다.

제 21 조 [신의성실 및 협조]
양 당사자는 본 계약의 목적을 달성하기 위하여 신의성실의 원칙에 따라 계약을 이행하며, 원활한 제작 진행을 위하여 필요한 자료 제공 및 검수 등 업무에 적극 협조한다.

제 22 조 [불가항력]
전쟁, 폭동, 자연재해, 감염병, 정부의 규제 등 '을'의 합리적인 통제 범위를 벗어난 불가항력적 사태로 인하여 계약 이행이 지연되거나 불가능해진 경우, '을'은 이에 대한 지체 책임을 지지 아니한다.

제 23 조 [재판관할]
본 계약과 관련하여 발생되는 분쟁은 당사자 간의 합의로 원만히 해결하되, 소송이 제기될 경우 '을'의 본점 소재지 관할 법원(또는 민사소송법상의 관할 법원)을 전속 관할 법원으로 한다.

제 24 조 [효력발생]
본 계약은 본 계약서에 양 당사자가 서명 또는 날인한 날로부터 효력을 발생한다.

제 25 조 [기타사항]
(1) 본 계약에 명시되지 않은 사항은 상관습 및 관련 법령(약관의 규제에 관한 법률, 민법 등)에 따른다.
(2) 본 계약의 내용을 변경하고자 할 경우에는 양 당사자의 서면 합의에 의하여만 변경할 수 있다.`;
